var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid lg:grid-cols-3 gap-16 lg:gap-[50px]" },
    _vm._l(_vm.faqs, function(faq) {
      return _c(
        "a",
        {
          staticClass: "bg-white p-24 lg:p-[50px] group",
          attrs: { ket: faq.id }
        },
        [
          faq.categories_objects[0]
            ? _c("div", {
                staticClass: "mb-16 lg:mb-24 text-20 lg:text-30 font-regular",
                domProps: { innerHTML: _vm._s(faq.categories_objects[0].name) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "text-orange text-20 font-regular flex flex-row items-end justify-between",
              attrs: { href: faq.link }
            },
            [
              _c("span", [_vm._v(_vm._s(faq.title.rendered))]),
              _vm._v(" "),
              _c("i", {
                staticClass:
                  "fas fa-chevron-right text-14 text-black group-hover:mr-[-8px] transition-all"
              })
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }